import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    height: 32,
    width: 32,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return (
    <img
      src="/ibict-simbolo-branco.svg"
      alt="IBICT"
      className={classes.img}
    />
  );
};
